"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _calendrical = _interopRequireDefault(require("calendrical"));

var _classnames = _interopRequireDefault(require("classnames"));

var _arrowPrev = _interopRequireDefault(require("../icons/arrow-prev.svg"));

var _arrowNext = _interopRequireDefault(require("../icons/arrow-next.svg"));

var _dateParser = require("../_utils/dateParser");

var _momentPropType = _interopRequireDefault(require("../_utils/momentPropType"));

require("./datePicker.sass");

var _ref4 = _react.default.createElement(_arrowPrev.default, null);

var _ref5 = _react.default.createElement(_arrowNext.default, null);

var DatePicker =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(DatePicker, _PureComponent);

  function DatePicker(props) {
    var _this;

    (0, _classCallCheck2.default)(this, DatePicker);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DatePicker).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "prev", function () {
      return _this.move(-1, 'month');
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "next", function () {
      return _this.move(1, 'month');
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "prevYear", function () {
      return _this.move(-1, 'year');
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "nextYear", function () {
      return _this.move(1, 'year');
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderDay", function (_ref, key) {
      var date = _ref.date,
          inCurrentMonth = _ref.inCurrentMonth,
          dayOfMonth = _ref.dayOfMonth;
      var m = (0, _moment.default)(date);
      var className = (0, _classnames.default)('datepicker-day', {
        'datepicker--disabled': _this.isDisabled(m),
        'datepicker-day--selected': _this.isSelected(m),
        'datepicker-day--current': m.isSame(Date.now(), 'day'),
        'datepicker-day--outside': !inCurrentMonth
      });
      return _react.default.createElement("div", {
        key: key,
        className: className,
        onClick: function onClick() {
          return _this.select(m);
        }
      }, dayOfMonth);
    });

    if (props.range) {
      _this.state.current = (0, _dateParser.getValidMomentDate)(props.to ? props.to : props.from);
    } else {
      _this.state.current = (0, _dateParser.getValidMomentDate)(props.value);
    }

    return _this;
  }

  (0, _createClass2.default)(DatePicker, [{
    key: "isSelected",
    value: function isSelected(date) {
      var _this$state = this.state,
          value = _this$state.value,
          from = _this$state.from,
          to = _this$state.to;

      if (!this.props.range) {
        return value && value.isSame(date, 'day');
      }

      if (!to) {
        return from && date.isSame(from, 'day');
      }

      return date.isBetween(from, to, null, '[]');
    }
  }, {
    key: "isDisabled",
    value: function isDisabled(date) {
      var _this$props = this.props,
          min = _this$props.min,
          max = _this$props.max;

      if (min && date.isBefore(min)) {
        return true;
      }

      return max && date.isAfter(max);
    }
  }, {
    key: "select",
    value: function select(date) {
      var _this2 = this;

      if (this.isDisabled(date)) {
        return;
      }

      if (this.props.range) {
        this.setState(function (_ref2) {
          var from = _ref2.from,
              to = _ref2.to;

          if (to || !from) {
            from = date;
            to = null;
          } else {
            to = _moment.default.max(from, date);
            from = _moment.default.min(from, date);
          }

          _this2.props.onChange && _this2.props.onChange(from, to);
          return {
            from: from,
            to: to
          };
        });
      } else {
        this.setState({
          value: date
        });
        this.props.onChange && this.props.onChange(date);
      }
    }
  }, {
    key: "move",
    value: function move(direction, step) {
      var _this3 = this;

      this.setState(function (_ref3) {
        var current = _ref3.current;
        current = current.clone().add(direction, step);

        if (_this3.props.min) {
          current = _moment.default.max(current, _this3.props.min);
        }

        if (_this3.props.max) {
          current = _moment.default.min(current, _this3.props.max);
        }

        return {
          current: current
        };
      });
    }
  }, {
    key: "renderWeek",
    value: function renderWeek() {
      var _this4 = this;

      return _calendrical.default.getWeeksInMonth(this.state.current.toDate(), {
        weekStartsWith: (0, _moment.default)().startOf('week').isoWeekday()
      }).map(function (week, index) {
        return _react.default.createElement("div", {
          key: index,
          className: "datepicker-week"
        }, week.map(_this4.renderDay));
      });
    }
  }, {
    key: "renderWeekDays",
    value: function renderWeekDays() {
      return _react.default.createElement("div", {
        className: "datepicker-week datepicker-week--dayNames"
      }, new Array(7).fill(0).map(function (_, key) {
        return _react.default.createElement("span", {
          className: "datepicker-day",
          key: key
        }, (0, _moment.default)().weekday(key).format('dd'));
      }));
    }
  }, {
    key: "renderYearNav",
    value: function renderYearNav() {
      var _this$props2 = this.props,
          min = _this$props2.min,
          max = _this$props2.max;
      var current = this.state.current;
      var prevYear = (0, _moment.default)(current).subtract(1, 'year');
      var nextYear = (0, _moment.default)(current).add(1, 'year');
      var prevEnabled = !min || prevYear.isSameOrAfter(min, 'year');
      var nextEnabled = !max || nextYear.isSameOrBefore(max, 'year');
      return _react.default.createElement("div", {
        className: "datepicker-years"
      }, _react.default.createElement("a", {
        className: (0, _classnames.default)('datepicker-year', {
          'datepicker--disabled': !prevEnabled
        }),
        onClick: this.prevYear
      }, prevYear.format('YYYY')), _react.default.createElement("span", {
        className: "datepicker-year datepicker-year--current"
      }, current.format('YYYY')), _react.default.createElement("a", {
        className: (0, _classnames.default)('datepicker-year', {
          'datepicker--disabled': !nextEnabled
        }),
        onClick: this.nextYear
      }, nextYear.format('YYYY')));
    }
  }, {
    key: "renderMonthNav",
    value: function renderMonthNav() {
      var _this$props3 = this.props,
          min = _this$props3.min,
          max = _this$props3.max;
      var current = this.state.current;
      var prevMonth = (0, _moment.default)(current).startOf('month').subtract(1, 'day');
      var nextMonth = (0, _moment.default)(current).add(1, 'month').startOf('month');
      var prevEnabled = !min || prevMonth.isSameOrAfter(min, 'month');
      var nextEnabled = !max || nextMonth.isSameOrBefore(max, 'month');
      return _react.default.createElement("div", {
        className: "datepicker-nav"
      }, _react.default.createElement("a", {
        className: (0, _classnames.default)('datepicker-nav-item', {
          'datepicker--disabled': !prevEnabled
        }),
        onClick: this.prev
      }, _ref4), _react.default.createElement("span", {
        className: "datepicker-nav-title"
      }, current.format('MMMM')), _react.default.createElement("a", {
        className: (0, _classnames.default)('datepicker-nav-item', {
          'datepicker--disabled': !nextEnabled
        }),
        onClick: this.next
      }, _ref5));
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: (0, _classnames.default)('datepicker', this.props.className)
      }, this.renderMonthNav(), _react.default.createElement("div", {
        className: "datepicker-days"
      }, this.renderWeekDays(), this.renderWeek()), this.renderYearNav());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props) {
      return {
        from: props.from ? (0, _dateParser.getValidMomentDate)(props.from) : undefined,
        to: props.to ? (0, _dateParser.getValidMomentDate)(props.to) : undefined,
        value: props.value ? (0, _dateParser.getValidMomentDate)(props.value) : undefined
      };
    }
  }]);
  return DatePicker;
}(_react.PureComponent);

exports.default = DatePicker;
DatePicker.propTypes = process.env.NODE_ENV !== "production" ? {
  onChange: _propTypes.default.func,
  range: _propTypes.default.bool,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.instanceOf(Date), _momentPropType.default]),
  from: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.instanceOf(Date), _momentPropType.default]),
  to: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.instanceOf(Date), _momentPropType.default])
} : {};